export const data = {
    countries: [
      "UStates",
      "United Kingdom",
      "European Countries",
      "Germany",
      "Canada",
      "Australia",
      "New Zealand",
    ],
    questions: [
      {
        country: "Australia",
        question: "What makes Australia an attractive study destination?",
        answer: "Australia offers world-class education, a diverse and inclusive society, vibrant cities, and a unique lifestyle, attracting students globally.",
      },
      {
        country: "Australia",
        question: "How competitive are entry requirements for Australian universities?",
        answer: null,
      },
      {
        country: "Australia",
        question: "Are there noteworthy scholarships for international students in Australia?",
        answer: null,
      },
      {
        country: "Australia",
        question: "Outline the process for obtaining an Australian student visa?",
        answer: null,
      },
      {
        country: "Australia",
        question: "Share insights into part-time work regulations for international students in Australia?",
        answer: null,
      },
      {
        country: "UStates",
        question: "Why is the United States a preferred destination for higher education?",
        answer: null,
      },
      {
        country: "UStates",
        question: "What is the application process for U.S. universities?",
        answer: null,
      },
      {
        country: "UStates",
        question: "What financial aid options are available for international students in the U.S.?",
        answer: null,
      },
      {
        country: "UStates",
        question: "What are the popular fields of study in the United States?",
        answer: null,
      },
      {
        country: "UStates",
        question: "What is the process for obtaining a U.S. student visa?",
        answer: null,
      },
      {
        country: "United Kingdom",
        question: "What makes UK universities highly regarded worldwide?",
        answer: null,
      },
      {
        country: "United Kingdom",
        question: "How does the UK post-study work visa benefit international students?",
        answer: null,
      },
      {
        country: "United Kingdom",
        question: "What are the living expenses like for students in the UK?",
        answer: null,
      },
      {
        country: "United Kingdom",
        question: "What is the process for applying to UK universities?",
        answer: null,
      },
      {
        country: "United Kingdom",
        question: "What scholarships are available for international students in the UK?",
        answer: null,
      },
      {
        country: "European Countries",
        question: "What are the benefits of studying in European countries?",
        answer: null,
      },
      {
        country: "European Countries",
        question: "How does the Erasmus program benefit international students?",
        answer: null,
      },
      {
        country: "European Countries",
        question: "What are the language requirements for studying in Europe?",
        answer: null,
      },
      {
        country: "European Countries",
        question: "What is the cost of living for students in European countries?",
        answer: null,
      },
      {
        country: "European Countries",
        question: "What are the top universities in Europe for international students?",
        answer: null,
      },
      {
        country: "Germany",
        question: "How affordable is education in Germany for international students?",
        answer: null,
      },
      {
        country: "Germany",
        question: "What are the requirements to enroll in German universities?",
        answer: null,
      },
      {
        country: "Germany",
        question: "What scholarships are available for studying in Germany?",
        answer: null,
      },
      {
        country: "Germany",
        question: "What are the benefits of studying in Germany for STEM students?",
        answer: null,
      },
      {
        country: "Germany",
        question: "How can international students find accommodation in Germany?",
        answer: null,
      },
      {
        country: "Canada",
        question: "Why is Canada a popular destination for international students?",
        answer: null,
      },
      {
        country: "Canada",
        question: "What are the eligibility criteria for a Canadian student visa?",
        answer: null,
      },
      {
        country: "Canada",
        question: "What part-time work opportunities are available for students in Canada?",
        answer: null,
      },
      {
        country: "Canada",
        question: "What are the top universities in Canada for international students?",
        answer: null,
      },
      {
        country: "Canada",
        question: "What are the costs of studying and living in Canada?",
        answer: null,
      },
      {
        country: "New Zealand",
        question: "What unique opportunities does New Zealand offer to international students?",
        answer: null,
      },
      {
        country: "New Zealand",
        question: "What is the process for obtaining a student visa for New Zealand?",
        answer: null,
      },
      {
        country: "New Zealand",
        question: "What are the work rights for international students in New Zealand?",
        answer: null,
      },
      {
        country: "New Zealand",
        question: "What are the top universities in New Zealand?",
        answer: null,
      },
      {
        country: "New Zealand",
        question: "How affordable is education in New Zealand for international students?",
        answer: null,
      },
    ],
  };
  
